module.exports = __webpack_public_path__ + "static/media/1006028.f1457907.png";